import { useCallback, useEffect, useState } from 'react'

import { DocumentTabPane } from '.'
import {
  closeUploadModal,
  openUploadModal,
  useFeatureDispatch,
  useFeatureState,
} from '../lib/state'
import { TabCategoryKeys as ModalTypes } from '../lib/constants'

import { RowTypes } from '../table/TableRows'
import { UploadDocumentType } from '@/constants/businessConstants'
import { useAnalyticsTrack } from '@/features/amplitude'
import FileUploadModal from '@/componentsV1/FileUpload/FileUploadModal'
import { UserDocumentsTable } from '../table'
import { DocumentSearchBarOnChangeData } from '../shared/DocumentsSearchBar'
import { TabPaneToolbar } from '../shared/TabPaneToolbar'
import { UploadDocumentButton } from '../shared/UploadDocumentButton'
import { Text } from '@/ui'

const COLUMNS = [
  {
    sortBy: 'fileName',
    title: 'File Name',
  },
  {
    sortBy: 'description',
    title: 'Description',
  },
  {
    sortBy: 'tag',
    title: 'Form Type',
  },
  {
    sortBy: null,
    title: 'Actions',
  },
]

export const Incorporation: DocumentTabPane = ({ documents, tableOptions }) => {
  const [filteredDocuments, setFilteredDocuments] = useState(documents)
  const { activeUploadModal, userDocumentCategoryId } = useFeatureState()
  const dispatch = useFeatureDispatch()
  const track = useAnalyticsTrack()

  useEffect(() => {
    setFilteredDocuments(documents)
  }, [documents])

  const onSearch = useCallback((data: DocumentSearchBarOnChangeData) => {
    setFilteredDocuments(data.filtered)
  }, [])

  const openModal = () => {
    track('clicked document upload', {
      document_category: ModalTypes.INCORPORATION_DOCUMENTS,
      document_subcategory: '',
    })
    dispatch?.(openUploadModal(ModalTypes.INCORPORATION_DOCUMENTS))
  }

  return (
    <>
      <TabPaneToolbar
        documents={documents}
        onSearch={onSearch}
        rightElement={<UploadDocumentButton onClick={openModal} />}
      >
        <Text>
          Share entity formation documents here, such as articles of
          incorporation, LLC approval, or Form 2553.
        </Text>
      </TabPaneToolbar>

      <UserDocumentsTable
        columns={COLUMNS}
        documents={filteredDocuments}
        rowType={RowTypes.INCORPORATION}
        tableOptions={tableOptions}
      />

      <FileUploadModal
        open={activeUploadModal === ModalTypes.INCORPORATION_DOCUMENTS}
        close={() => dispatch?.(closeUploadModal())}
        documentType={UploadDocumentType.INCORPORATION}
        userFacing
        categoryId={userDocumentCategoryId}
      />
    </>
  )
}

Incorporation.paneDescription =
  'Please use this section to upload any entity formation documents, such as articles of incorporation, LLC approval, S corporation Form 2553, etc.'
Incorporation.paneTitle = 'Incorporation'
